<template>
  <v-select
    id="member-select"
    v-model ="filter.membroLocal"
    item-text ="nome"
    item-name ="membroId"
    :items="members"
    label ="Membro"
    placeholder ="Selecione um Membro Existente"
    v-on:change ="$emit('onChange')"
    :disabled = "disabled"
    :return-object=true
  >
    <template slot="no-data">
      Nenhum Grupo retornado
    </template>
  </v-select>
</template>

<script>
import { memberAPI } from '../MemberAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppMemberCombobox',
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false }
  },
  mounted () {
    this.loadMembers()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    loadMembers () {
      this.setLoading(true)
      memberAPI.getMembersByCity(this.filter.municipioId)
        .then(resp => {
          this.members = resp.data
          this.setLoading(false)
        })
        .catch(this.setLoading(false))
    }
  },
  data () {
    return {
      members: []
    }
  }
}
</script>
